// data/constants.ts
import { Service, Testimonial, GalleryItem, Page } from '../types';

export const whyChooseUsItems = [
  { text: "30+ Years of Experience: Unmatched expertise for any roofing challenge.", icon: "🏆" },
  { text: "Local & Trusted: Proudly serving Avon Park and surrounding communities.", icon: "🏠" },
  { text: "Quality Materials: Only the best for durability and longevity.", icon: "🧱" },
  { text: "Expert Craftsmanship: Skilled, certified roofers dedicated to excellence.", icon: "🛠️" },
  { text: "Customer Satisfaction: Your happiness is our top priority.", icon: "😊" },
  { text: "Free, No-Obligation Estimates: Honest assessments of your roofing needs.", icon: "📋" },
];

export const services: Service[] = [
  {
    title: 'Residential Roofing',
    icon: '🏠',
    description: [
      'New Roof Installations (Shingle, Metal, Flat Roofs)',
      'Re-roofing and Roof Replacement',
      'Storm Damage Repair & Leak Detection',
      'Preventative Maintenance Programs',
    ],
  },
  {
    title: 'Roof Repair',
    icon: '🛠️',
    description: [
      'Prompt Leak Repairs',
      'Missing or Damaged Shingle Replacement',
      'Flashing Repair and Replacement',
      'Soffit and Fascia Repair',
      'Emergency Roof Tarping Services',
    ],
  },
  {
    title: 'New Roof Installation',
    icon: '🏗️',
    description:
      'Building a new home? We provide expert new roof installation, working closely with builders and homeowners to ensure the highest standards from day one.',
  },
  {
    title: 'Roof Inspections',
    icon: '🔍',
    description: [
      'Comprehensive Roof Inspections',
      'Storm Damage Assessments',
      'Pre-Purchase Home Inspections',
      'Insurance Claim Documentation',
    ],
  },
];

export const testimonials: Testimonial[] = [
  {
    quote: "This company is awesome!! From David Kelli, Rueban & wagon the crew was 100% professional they did an awesome job. Super happy with the quality and care of their work will definitely recommend to friends and family these guys are number one in my book!! This company is family owned and local so support local!!",
    author: "Susan Greenberg",
    location: "Local Guide"
  },
  {
    quote: "They did an amazing job on our roof in Lake Placid. Every time we called or messaged they were quick to respond and the roof looks amazing love it",
    author: "Christopher Robinson",
    location: "Lake Placid, FL"
  },
  {
    quote: "I love my new roof! This company did an amazing job on my roof. I have a larger sized roof and they originally thought they would take 2.5 days to complete but they were able to tear down and complete the work in two days! I was amazed.",
    author: "Casie Smith",
    location: "Local Customer"
  },
  {
    quote: "David. John, Ruben, Kelli and ALL the crew we want to thank you for a quick, professional, and stress-free experience. This company is top-notch customer service company with excellent workmanship. Our roof is PERFECT.",
    author: "Patricia Carter",
    location: "Local Customer"
  },
  {
    quote: "We recently had our roof replaced by Lemay Roofing and could not have had a better experience. This company gave the best price, showed up when promised, finished the job in 2 days, including a small boat house, even though they encountered challenges.",
    author: "Victor Hull",
    location: "Local Customer"
  },
  {
    quote: "Mr. Lemay took good care of me. Him and his crew are very professional. They treat you like family. If you need a good roofer look no further. I highly recommend Mr. Lemay. He does great quality work at a fair price.",
    author: "William Santiago",
    location: "Local Customer"
  },
  {
    quote: "Above and beyond. I could not be more pleased with my experience with this company. It took them 3 days to do a complete shingle roof on my moms house. They cleaned up everything, every day. You wouldn't know a roofing company was there.",
    author: "Christine Cooper",
    location: "Local Guide"
  },
  {
    quote: "Mr. Lemay was very professional and his prices were the lowest. Not only was he professional he was extremely kind. I knew then that I had chosen the right company to replace my roof. Mr. Lemay and his crew worked very hard, even on a challenging day.",
    author: "Rosetta Adams",
    location: "Local Customer"
  },
  {
    quote: "David and his crew are unbeatable with their company and with their crew they stand true to their word. Their hard work and quality shows unbeatable in my roof. They are very professional but yet treats you like family at the same time, that is what makes them a 5 star company in my mind.",
    author: "Nikki Charles",
    location: "Local Customer"
  },
  {
    quote: "Great LOCAL company. Very easy to work with! The pricing is unbeatable. Lemay company was very kind and professional. We had damage from Irma and they replaced it with exactly what we wanted! I highly recommend Lemay.",
    author: "T K",
    location: "Local Customer"
  },
  {
    quote: "Very professional as well as straight up and honest to work with. They did a topnotch job on a patio home we have. Recommend highly. Also, quoted the best price covering all aspects of roofing details required. Out of 12 different quotes, LeMay Roofing was the best and responded immediately.",
    author: "Diane Kulbacki",
    location: "Local Customer"
  },
  {
    quote: "This is a fantastic family owned business. Such a great experience working with them. They went above and beyond to make sure everything was brought up to their quality standards. The crew was awesome and cleaned up like they were never there. I would very highly recommend them!",
    author: "Juleana Sheldon",
    location: "Local Customer"
  }
];

export const galleryItems: GalleryItem[] = [
  { id: 1, thumbnailUrl: 'https://placehold.co/400x300/7c3aed/ffffff?text=Shingle+Roof', fullUrl: 'https://placehold.co/800x600/7c3aed/ffffff?text=Residential+Shingle+Roof', caption: 'New Shingle Roof - Avon Park', altText: "Residential shingle roof" },
  { id: 3, thumbnailUrl: 'https://placehold.co/400x300/2563eb/ffffff?text=Metal+Roof', fullUrl: 'https://placehold.co/800x600/2563eb/ffffff?text=Metal+Roof+Installation', caption: 'Metal Roof Installation - Wauchula', altText: "New metal roof" },
  { id: 5, thumbnailUrl: 'https://placehold.co/400x300/be185d/ffffff?text=Storm+Damage', fullUrl: 'https://placehold.co/800x600/be185d/ffffff?text=Storm+Damage+Restoration', caption: 'Post-Storm Roof Restoration', altText: "Roof restored after storm damage" },
  { id: 6, thumbnailUrl: 'https://placehold.co/400x300/16a34a/ffffff?text=Roof+Replacement', fullUrl: 'https://placehold.co/800x600/16a34a/ffffff?text=Complete+Roof+Replacement', caption: 'Complete Roof Replacement - Sebring', altText: "Complete roof replacement" },
];

export const navItems: { page: Page; label: string; isButton?: boolean }[] = [
  { page: 'Home', label: 'Home' },
  { page: 'About', label: 'About' },
  { page: 'Services', label: 'Services' },
  // { page: 'OurWork', label: 'Portfolio' },
  { page: 'Gallery', label: 'Gallery' },
  { page: 'Blog', label: 'Blog' },
  { page: 'Testimonials', label: 'Reviews' },
  { page: 'Contact', label: 'Contact' },
  { page: 'RequestQuote', label: 'Free Quote', isButton: true },
];

export const serviceOptions = [
  { value: "Residential Roofing", label: "Residential Roofing" },
  { value: "Roof Repair", label: "Roof Repair" },
  { value: "New Roof Installation", label: "New Roof Installation" },
  { value: "Roof Inspection", label: "Roof Inspection" },
  { value: "Other", label: "Other" },
];

// US states for the quote form. A constrained list means the field cannot carry
// junk: both known spam submissions put keyboard mash here ("Kmyxfq",
// "Elqivt"), which a free-text input accepted without complaint.
// Florida first since effectively every real lead is local.
export const stateOptions = [
  { value: "FL", label: "Florida" },
  { value: "AL", label: "Alabama" }, { value: "AK", label: "Alaska" },
  { value: "AZ", label: "Arizona" }, { value: "AR", label: "Arkansas" },
  { value: "CA", label: "California" }, { value: "CO", label: "Colorado" },
  { value: "CT", label: "Connecticut" }, { value: "DE", label: "Delaware" },
  { value: "DC", label: "District of Columbia" }, { value: "GA", label: "Georgia" },
  { value: "HI", label: "Hawaii" }, { value: "ID", label: "Idaho" },
  { value: "IL", label: "Illinois" }, { value: "IN", label: "Indiana" },
  { value: "IA", label: "Iowa" }, { value: "KS", label: "Kansas" },
  { value: "KY", label: "Kentucky" }, { value: "LA", label: "Louisiana" },
  { value: "ME", label: "Maine" }, { value: "MD", label: "Maryland" },
  { value: "MA", label: "Massachusetts" }, { value: "MI", label: "Michigan" },
  { value: "MN", label: "Minnesota" }, { value: "MS", label: "Mississippi" },
  { value: "MO", label: "Missouri" }, { value: "MT", label: "Montana" },
  { value: "NE", label: "Nebraska" }, { value: "NV", label: "Nevada" },
  { value: "NH", label: "New Hampshire" }, { value: "NJ", label: "New Jersey" },
  { value: "NM", label: "New Mexico" }, { value: "NY", label: "New York" },
  { value: "NC", label: "North Carolina" }, { value: "ND", label: "North Dakota" },
  { value: "OH", label: "Ohio" }, { value: "OK", label: "Oklahoma" },
  { value: "OR", label: "Oregon" }, { value: "PA", label: "Pennsylvania" },
  { value: "RI", label: "Rhode Island" }, { value: "SC", label: "South Carolina" },
  { value: "SD", label: "South Dakota" }, { value: "TN", label: "Tennessee" },
  { value: "TX", label: "Texas" }, { value: "UT", label: "Utah" },
  { value: "VT", label: "Vermont" }, { value: "VA", label: "Virginia" },
  { value: "WA", label: "Washington" }, { value: "WV", label: "West Virginia" },
  { value: "WI", label: "Wisconsin" }, { value: "WY", label: "Wyoming" },
];

export const mapEmbedUrl = "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d28080.00964092734!2d-81.5258908419704!3d27.596300481613173!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88dd50d3a0a10921%3A0x401b681018888799!2sAvon%20Park%2C%20FL%2C%20USA!5e0!3m2!1sen!2s!4v1683816000000!5m2!1sen!2s";
